import axiosClient from "../services/axiosInstance";

export const newsService = {
  getNews(params) {
    return axiosClient.get("/news", {
      params,
    });
  },

  getNewsDetail(slug) {
    return axiosClient.get(`/news/${slug}`);
  },

  createNews(data) {
    return axiosClient.post("/news", data);
  },

  updateNews(id, data) {
    return axiosClient.put(`/news/${id}`, data);
  },

  deleteNews(id) {
    return axiosClient.delete(`/news/${id}`);
  },
};